<h3 class="marine-insurance-application-note-action">{{ "PLEASE_FILL_INFORMATION" | translate }}</h3>

<div class="marine-insurance-application-note">
  <p class="marine-insurance-application-note-first">{{ "MARINE_INSURANCE_QUOTE_FILL_HINT_1" | translate }}</p>
  <p class="marine-insurance-application-note-hint">
    {{ "MARINE_INSURANCE_QUOTE_FILL_HINT_1_SUB" | translate }}
    <a href="" target="_blank" [routerLink]="['/', 'contact-support']">{{ "CONTACT_US_SM" | translate }}</a>
    .
  </p>
  <p class="marine-insurance-application-note-secondary" *ngIf="isShowAfterCompletion">
    {{ "MARINE_INSURANCE_QUOTE_FILL_HINT_2" | translate : { entity: entity || "" } }}
  </p>
</div>

<section>
  <date-picker
    id="dateTimeFrom"
    placeholder="LABELS.DEPARTURE_DATE"
    name="dateTimeFrom"
    label="LABELS.DEPARTURE_DATE"
    [fc]="formGroup.get('shippingDate')"
    *ngIf="isShowDepartureDate"
  ></date-picker>

  <div class="marine-insurance-application-date-error" *ngIf="dateErrorAir || dateErrorOcean">
    <div class="marine-insurance-application-date-error-icon">
      <img src="assets/icons/icon_warning_black_sm.svg" />
    </div>
    <p class="marine-insurance-application-date-error-text" *ngIf="dateErrorAir">
      {{ "MARINE_INSURANCE_QUOTE_VALIDATION_AIR" | translate }}
    </p>
    <p class="marine-insurance-application-date-error-text" *ngIf="dateErrorOcean">
      {{ "MARINE_INSURANCE_QUOTE_VALIDATION_OCEAN" | translate }}
    </p>
  </div>

  <div class="marine-insurance-application-col-value">
    <app-control-wrapper
      [control]="formGroup.get('insuredAmount')"
      [helper]="'INSURED_VALUE_HELPER'"
      [errors]="errors.insuredAmount"
      [errorsOverrideParams]="{ max: { limit: insuredAmountLimit | currency : DEFAULT_CURRENCY_CODE : 'symbol' : '1.2-2' } }"
    >
      <label for="insuredAmount" control-label>{{ "INSURED_VALUE" | translate }}</label>
      <div class="d-flex" control-wrapper>
        <input
          id="insuredAmount"
          class="form-control"
          type="text"
          inputmode="numeric"
          [pattern]="currencyInputMap.pattern"
          [mask]="currencyInputMap.mask"
          [thousandSeparator]="currencyInputMap.thousandSeparator"
          [appMaskErrorTooltip]="currencyInputMap.maskErrorTooltip"
          [formControl]="formGroup.get('insuredAmount')"
        />
        <div class="form-control currency">USD</div>
      </div>
    </app-control-wrapper>
  </div>

  <p class="marine-insurance-application-add-cif">
    {{ "MARINE_INSURANCE_ADD_CIF" | translate }}
    <button class="marine-insurance-application-add-cif-btn" [disabled]="cifAdded" (click)="addCif()">
      {{ "BUTTON.ADD" | translate }}+{{ cifPercentage }}%
    </button>
  </p>

  <p class="marine-insurance-application-categories-header">{{ "COMMODITIES_CATEGORY" | translate }}</p>

  <div
    class="marine-insurance-application-categories-item"
    [ngClass]="{ 'is-selected': formGroup.get('commodityId').value === commodity.id }"
    *ngFor="let commodity of commodities$ | async"
  >
    <div class="marine-insurance-application-categories-item-header">
      <app-radio-button
        [control]="formGroup.get('commodityId')"
        [id]="'commodity-' + commodity.id"
        [label]="commodity.name"
        [value]="commodity.id"
        [name]="'commodity-id'"
      ></app-radio-button>
    </div>
    <div class="marine-insurance-application-categories-item-body" *ngIf="formGroup.get('commodityId').value === commodity.id">
      <p
        class="marine-insurance-application-categories-item-body-description"
        [innerHTML]="getCommodityDescription(commodity.id) | translate"
        [ngClass]="{ 'is-opened': isOpenedDescription }"
      ></p>

      <div class="marine-insurance-application-categories-item-body-transportation" *ngIf="isShowTransportationMode(commodity.id)">
        <p class="marine-insurance-application-categories-item-body-transportation-header">
          {{ "PLEASE_CHOOSE_RELEVANT_TRANSPORTING_METHOD" | translate }}
        </p>

        <div class="marine-insurance-application-categories-item-body-transportation-items">
          <app-radio-button
            [control]="formGroup.get('typeOfShipment')"
            [id]="'typeOfShipment-breakbulk'"
            [label]="'NON_CONTAINERIZED'"
            [value]="enumInsuranceShipmentType.BREAKBULK"
            [name]="'typeOfShipment'"
          ></app-radio-button>

          <app-radio-button
            [control]="formGroup.get('typeOfShipment')"
            [id]="'typeOfShipment-fca'"
            [label]="'CONTAINERIZED'"
            [value]="enumInsuranceShipmentType.FULL_CONTAINER"
            [name]="'typeOfShipment'"
          ></app-radio-button>
        </div>

        <date-picker
          id="manufactureDate"
          labelClass="mt-2"
          placeholder="LABELS.MANUFACTURE_YEAR"
          minMode="year"
          [maxDate]="maxManufaturerDate"
          dateInputFormat="YYYY"
          name="manufactureDate"
          label="MARINE_INSURANCE_MANUFACTURE_LABEL"
          [showHelper]="false"
          [fc]="formGroup.get('manufactureDate')"
          [errors]="errors.manufactureDate"
        ></date-picker>
      </div>

      <div
        class="marine-insurance-application-categories-item-body-see-more"
        *ngIf="isShowMore(commodity.id)"
        (click)="setOpenedDescription()"
      >
        {{ (isOpenedDescription ? "BUTTON.CLOSE" : "BUTTON.SEE_MORE") | translate }}
        <div class="marine-insurance-application-categories-item-body-see-more-icon" [ngClass]="{ 'is-opened': isOpenedDescription }">
          <img src="assets/icons/icon_chevron_down_sm.svg" />
        </div>
      </div>
    </div>
  </div>

  <div class="marine-insurance-application-description">
    <app-control-wrapper [control]="formGroup.get('goodsTypeDescription')" [isShowHelper]="false">
      <label for="goodsTypeDescription" control-label>{{ "MARINE_INSURANCE_DESCRIPTION_LABEL" | translate }}</label>
      <textarea
        class="form-control"
        id="goodsTypeDescription"
        name="goodsTypeDescription"
        rows="2"
        control-wrapper
        [formControl]="formGroup.get('goodsTypeDescription')"
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
        [mask]="'F*'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [placeholder]="'MARINE_INSURANCE_DESCRIPTION_HINT' | translate"
      ></textarea>
    </app-control-wrapper>
  </div>
</section>

<section class="marine-insurance-application-footer">
  <button type="submit" class="btn btn-primary" [disabled]="isSaving" (click)="onSave()">
    {{ (isEdit ? "BUTTON.SAVE" : "BUTTON.CONTINUE") | translate }}
  </button>
</section>

<loading-spinner [show]="isSaving"></loading-spinner>
